import Vue from 'vue'

const mutations = {

    setExportForm(state, { display, type }) {
        Vue.set(state.formExport, 'display', display)
        Vue.set(state.formExport, 'type', type)
    }
}

export default mutations
